var map = {
	"./AC.svg": "412a",
	"./AD.svg": "0c45",
	"./AE.svg": "a9cc",
	"./AF.svg": "24f9",
	"./AG.svg": "d69d",
	"./AI.svg": "6504",
	"./AL.svg": "8e87",
	"./AM.svg": "cf96",
	"./AO.svg": "9938",
	"./AQ.svg": "75cc",
	"./AR.svg": "f3e7",
	"./AS.svg": "4743",
	"./AT.svg": "4517",
	"./AU.svg": "9699",
	"./AW.svg": "eda0",
	"./AX.svg": "8886",
	"./AZ.svg": "731d",
	"./BA.svg": "98d5",
	"./BB.svg": "8513",
	"./BD.svg": "cce7",
	"./BE.svg": "7077",
	"./BF.svg": "cd5f",
	"./BG.svg": "cb63",
	"./BH.svg": "28ff",
	"./BI.svg": "cecc",
	"./BJ.svg": "0bca",
	"./BL.svg": "b4d9",
	"./BM.svg": "0547",
	"./BN.svg": "ab61",
	"./BO.svg": "c26e",
	"./BQ.svg": "3372",
	"./BR.svg": "535d",
	"./BS.svg": "b149",
	"./BT.svg": "0d9a",
	"./BV.svg": "5a80",
	"./BW.svg": "83d7",
	"./BY.svg": "5030",
	"./BZ.svg": "9759",
	"./CA.svg": "0b70",
	"./CC.svg": "8ac5",
	"./CD.svg": "bc64",
	"./CF.svg": "07a3",
	"./CG.svg": "42ff1",
	"./CH.svg": "804d",
	"./CI.svg": "744c",
	"./CK.svg": "8b08",
	"./CL.svg": "df11",
	"./CM.svg": "c93f",
	"./CN.svg": "fc89",
	"./CO.svg": "586e",
	"./CP.svg": "6bf3",
	"./CR.svg": "9c7b",
	"./CU.svg": "a4da",
	"./CV.svg": "30bb",
	"./CW.svg": "583be",
	"./CX.svg": "914c",
	"./CY.svg": "72b3",
	"./CZ.svg": "d5e2",
	"./DE.svg": "6bf2",
	"./DG.svg": "9086",
	"./DJ.svg": "77f2",
	"./DK.svg": "1899",
	"./DM.svg": "0988",
	"./DO.svg": "148e",
	"./DZ.svg": "aaf5",
	"./EA.svg": "55d2",
	"./EC.svg": "4363",
	"./EE.svg": "1903",
	"./EG.svg": "8c99",
	"./EH.svg": "7860",
	"./EN.svg": "f30c",
	"./ER.svg": "3097",
	"./ES.svg": "ddff",
	"./ET.svg": "8de5",
	"./EU.svg": "4ef7",
	"./FI.svg": "956d",
	"./FJ.svg": "4eea",
	"./FK.svg": "acc5",
	"./FM.svg": "ac4c",
	"./FO.svg": "2eb6",
	"./FR.svg": "0e42",
	"./GA.svg": "5103",
	"./GB.svg": "29fb",
	"./GD.svg": "43c3",
	"./GE.svg": "161e",
	"./GF.svg": "a0e3",
	"./GG.svg": "ed63",
	"./GH.svg": "0d84",
	"./GI.svg": "f28f",
	"./GL.svg": "3198",
	"./GM.svg": "9bdd2",
	"./GN.svg": "7611",
	"./GP.svg": "391b",
	"./GQ.svg": "5444",
	"./GR.svg": "0d0b",
	"./GS.svg": "0fe6",
	"./GT.svg": "29aa",
	"./GU.svg": "1b48",
	"./GW.svg": "7066",
	"./GY.svg": "89b0",
	"./HK.svg": "f8bb5",
	"./HM.svg": "5e121",
	"./HN.svg": "611e",
	"./HR.svg": "c9c8",
	"./HT.svg": "76b3",
	"./HU.svg": "17d7",
	"./IC.svg": "90a7",
	"./ID.svg": "f7e5",
	"./IE.svg": "3c01",
	"./IL.svg": "0356",
	"./IM.svg": "b16b",
	"./IN.svg": "1358",
	"./IO.svg": "75bc",
	"./IQ.svg": "03ae",
	"./IR.svg": "f662",
	"./IS.svg": "a74e",
	"./IT.svg": "f8dd",
	"./JE.svg": "262b",
	"./JM.svg": "f39c",
	"./JO.svg": "21c5",
	"./JP.svg": "9bf5",
	"./KE.svg": "6dea",
	"./KG.svg": "20cf1",
	"./KH.svg": "b9b3",
	"./KI.svg": "0d16",
	"./KM.svg": "c521",
	"./KN.svg": "003d",
	"./KP.svg": "83db",
	"./KR.svg": "c705",
	"./KW.svg": "adc8",
	"./KY.svg": "67df",
	"./KZ.svg": "3565",
	"./LA.svg": "c7e1",
	"./LB.svg": "a6eb",
	"./LC.svg": "a355",
	"./LI.svg": "2af0",
	"./LK.svg": "76ba",
	"./LR.svg": "8c88",
	"./LS.svg": "07f0",
	"./LT.svg": "e6a6",
	"./LU.svg": "5cb6",
	"./LV.svg": "deb4",
	"./LY.svg": "3276",
	"./MA.svg": "477b",
	"./MC.svg": "cc07",
	"./MD.svg": "20dc",
	"./ME.svg": "c8b0",
	"./MF.svg": "7819",
	"./MG.svg": "8307",
	"./MH.svg": "1244",
	"./MK.svg": "7d6b",
	"./ML.svg": "a908",
	"./MM.svg": "b53d",
	"./MN.svg": "24f3",
	"./MO.svg": "3076",
	"./MP.svg": "53c6",
	"./MQ.svg": "b4a4",
	"./MR.svg": "b424",
	"./MS.svg": "53f0",
	"./MT.svg": "3b62",
	"./MU.svg": "5563",
	"./MV.svg": "a7f6",
	"./MW.svg": "879b",
	"./MX.svg": "9970",
	"./MY.svg": "ba9e",
	"./MZ.svg": "8d1a",
	"./NA.svg": "46a2",
	"./NC.svg": "7226",
	"./NE.svg": "8de2",
	"./NF.svg": "4058",
	"./NG.svg": "9d51",
	"./NI.svg": "d11b",
	"./NL.svg": "bb13",
	"./NO.svg": "510b",
	"./NP.svg": "da44",
	"./NR.svg": "1f77",
	"./NU.svg": "b5d6",
	"./NZ.svg": "bb8e",
	"./OM.svg": "6e0c",
	"./PA.svg": "b034",
	"./PE.svg": "a99c",
	"./PF.svg": "78a8",
	"./PG.svg": "98de",
	"./PH.svg": "fc4e",
	"./PK.svg": "5d62",
	"./PL.svg": "4902",
	"./PM.svg": "112a",
	"./PN.svg": "d7a8",
	"./PR.svg": "4360b",
	"./PS.svg": "36e8",
	"./PT.svg": "094e",
	"./PW.svg": "4cda",
	"./PY.svg": "b48a",
	"./QA.svg": "4377",
	"./RE.svg": "78b87",
	"./RO.svg": "0914",
	"./RS.svg": "0d16a",
	"./RU.svg": "b66f",
	"./RW.svg": "0cf5",
	"./SA.svg": "5b50",
	"./SB.svg": "7aa9",
	"./SC.svg": "f170",
	"./SCOTLAND.svg": "77b4",
	"./SD.svg": "7a1c",
	"./SE.svg": "62dd",
	"./SG.svg": "da41",
	"./SH.svg": "8759",
	"./SI.svg": "d497",
	"./SJ.svg": "64ac",
	"./SK.svg": "6fef9",
	"./SL.svg": "760c",
	"./SM.svg": "cdfb",
	"./SN.svg": "ff5c",
	"./SO.svg": "261b",
	"./SR.svg": "8bdf",
	"./SS.svg": "1f29",
	"./ST.svg": "cbf2",
	"./SV.svg": "8787",
	"./SX.svg": "d592",
	"./SY.svg": "7ad8",
	"./SZ.svg": "3977",
	"./TA.svg": "f875",
	"./TC.svg": "37b6",
	"./TD.svg": "d8a8",
	"./TF.svg": "fab9",
	"./TG.svg": "5473",
	"./TH.svg": "98f6",
	"./TJ.svg": "f760",
	"./TK.svg": "fa55",
	"./TL.svg": "8c82",
	"./TM.svg": "8572",
	"./TN.svg": "07ee",
	"./TO.svg": "803e",
	"./TR.svg": "b4d1",
	"./TT.svg": "3c06",
	"./TV.svg": "5f5c",
	"./TW.svg": "26b5",
	"./TZ.svg": "1987",
	"./UA.svg": "9fe3",
	"./UG.svg": "f78b",
	"./UM.svg": "c5cb",
	"./UN.svg": "9509",
	"./US.svg": "083c",
	"./UY.svg": "467b",
	"./UZ.svg": "816c",
	"./VA.svg": "6d41",
	"./VC.svg": "bc3d",
	"./VE.svg": "fd99",
	"./VG.svg": "d50c",
	"./VI.svg": "ed34",
	"./VN.svg": "e842",
	"./VU.svg": "8e94",
	"./WALES.svg": "4495",
	"./WF.svg": "80f9",
	"./WS.svg": "dbcf",
	"./XK.svg": "6955",
	"./YE.svg": "7eb6",
	"./YT.svg": "95f6",
	"./ZA.svg": "57cf",
	"./ZM.svg": "bc6d",
	"./ZW.svg": "ce48"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ab08";